<div class="min-h-screen bg-[#05070F] flex relative">
  <!-- 语言切换（右上角，登录前可用）-->
  <div class="absolute top-4 right-4 z-50">
    <app-lang-switch />
  </div>
  <!-- 左侧 hero（中大屏显示）-->
  <div
    class="hidden md:flex flex-1 relative overflow-hidden bg-gradient-to-br from-[#0B1026] to-[#05070F]"
  >
    <div class="absolute -top-12 -left-12 w-52 h-52 rounded-full bg-[#33E6FF]/20"></div>
    <div class="absolute bottom-24 -right-12 w-72 h-72 rounded-full bg-[#FF3CAC]/15"></div>
    <div
      class="absolute top-28 right-16 w-28 h-28 rounded-full bg-[#33E6FF]/10 shadow-[0_0_60px_#33E6FF]"
    ></div>
    <div class="relative z-10 m-auto text-center px-8">
      <svg
        class="w-20 h-20 mx-auto text-[#33E6FF]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="1.5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3"
        />
      </svg>
      <div class="text-5xl font-bold tracking-wide mt-5">
        <span class="text-[#33E6FF]">EP</span><span class="text-white">inno</span>
      </div>
      <div class="text-white/70 mt-2">{{ 'login.tagline' | translate }}</div>
    </div>
  </div>

  <!-- 右侧登录面板（玻璃拟态）-->
  <div class="flex-1 flex items-center justify-center p-6">
    <div
      class="w-full max-w-[420px] rounded-2xl border border-[#33E6FF]/30 bg-white/[0.08] backdrop-blur-xl p-8 shadow-[0_0_28px_rgba(51,230,255,0.15),0_0_40px_rgba(255,60,172,0.08)]"
    >
      @if (!mfaTicket()) {
        <!-- 主因子：密码 / OAuth / Passkey -->
        <h2 class="text-2xl font-bold text-[#F7FAFC] text-center">{{ 'login.welcomeBack' | translate }}</h2>
        <p class="text-white/70 text-center text-sm mt-1">{{ 'login.signInToContinue' | translate }}</p>

        <form (submit)="$event.preventDefault(); submit()" class="mt-8 space-y-5">
          <div class="relative">
            <svg
              class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#33E6FF]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
              />
            </svg>
            <input
              type="text"
              [value]="username()"
              (input)="setUsername($event)"
              autocomplete="username"
              [placeholder]="'login.usernameOrEmail' | translate"
              class="w-full pl-10 pr-4 py-3 rounded-lg bg-white/[0.06] border border-[#33E6FF]/30 text-white placeholder-white/40 focus:outline-none focus:border-[#33E6FF] focus:ring-1 focus:ring-[#33E6FF]"
            />
          </div>

          <div class="relative">
            <svg
              class="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#33E6FF]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
            <input
              type="password"
              [value]="password()"
              (input)="setPassword($event)"
              autocomplete="current-password"
              [placeholder]="'login.password' | translate"
              class="w-full pl-10 pr-4 py-3 rounded-lg bg-white/[0.06] border border-[#33E6FF]/30 text-white placeholder-white/40 focus:outline-none focus:border-[#33E6FF] focus:ring-1 focus:ring-[#33E6FF]"
            />
          </div>

          <div class="text-right">
            <a class="text-[#33E6FF] text-sm cursor-pointer hover:underline">{{ 'login.forgotPassword' | translate }}</a>
          </div>

          @if (error()) {
            <div class="text-sm text-[#FF3CAC] bg-[#FF3CAC]/10 rounded-lg px-3 py-2">
              {{ error()! | translate }}
            </div>
          }

          <button
            type="submit"
            [disabled]="loading()"
            class="w-full py-3 rounded-lg font-bold tracking-wide text-white bg-gradient-to-r from-[#33E6FF] to-[#FF3CAC] shadow-[0_6px_18px_rgba(51,230,255,0.3)] hover:opacity-95 disabled:opacity-60 transition"
          >
            {{ (loading() ? 'login.loggingIn' : 'login.login') | translate }}
          </button>
        </form>

        <!-- 分隔 -->
        <div class="flex items-center gap-3 my-6">
          <div class="h-px flex-1 bg-white/10"></div>
          <span class="text-white/40 text-xs">{{ 'login.orUse' | translate }}</span>
          <div class="h-px flex-1 bg-white/10"></div>
        </div>

        <!-- 一键登录 -->
        <div class="space-y-3">
          <button
            type="button"
            (click)="passkey()"
            [disabled]="passkeyLoading()"
            class="w-full py-3 rounded-lg flex items-center justify-center gap-2 border border-[#33E6FF]/40 bg-[#33E6FF]/10 text-[#33E6FF] hover:bg-[#33E6FF]/20 disabled:opacity-60 transition"
          >
            <svg
              class="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
            {{ (passkeyLoading() ? 'login.verifying' : 'login.passkeyLogin') | translate }}
          </button>
        </div>
      } @else {
        <!-- 二次因素：TOTP 动态验证码 -->
        <h2 class="text-2xl font-bold text-[#F7FAFC] text-center">{{ 'login.twoFactor' | translate }}</h2>
        <p class="text-white/70 text-center text-sm mt-1">{{ 'login.enterTotp' | translate }}</p>

        <form (submit)="$event.preventDefault(); verifyMfa()" class="mt-8 space-y-5">
          <input
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="10"
            [value]="totpCode()"
            (input)="setTotp($event)"
            [placeholder]="'login.totpPlaceholder' | translate"
            class="w-full px-4 py-3 rounded-lg bg-white/[0.06] border border-[#33E6FF]/30 text-white text-center tracking-[0.3em] placeholder-white/40 focus:outline-none focus:border-[#33E6FF] focus:ring-1 focus:ring-[#33E6FF]"
          />

          @if (error()) {
            <div class="text-sm text-[#FF3CAC] bg-[#FF3CAC]/10 rounded-lg px-3 py-2">
              {{ error()! | translate }}
            </div>
          }

          <button
            type="submit"
            [disabled]="loading()"
            class="w-full py-3 rounded-lg font-bold tracking-wide text-white bg-gradient-to-r from-[#33E6FF] to-[#FF3CAC] shadow-[0_6px_18px_rgba(51,230,255,0.3)] hover:opacity-95 disabled:opacity-60 transition"
          >
            {{ (loading() ? 'login.verifying' : 'login.verifyAndLogin') | translate }}
          </button>
          <button
            type="button"
            (click)="cancelMfa()"
            class="w-full text-white/60 text-sm hover:text-white"
          >
            {{ 'login.back' | translate }}
          </button>
        </form>
      }
    </div>
  </div>
</div>
